
const GTAG_EVENT = 'GTAG_EVENT'
const GTAG_CONFIG = 'GTAG_CONFIG'
const state = {}
const getters = {}
const mutations = {}
const actions = {
  [GTAG_EVENT]: async ({ state, commit }, params) => {
    // console.log('GTAG_EVENT', params.action, params.data)
    gtag('event', params.action, params.data)
  },
  [GTAG_CONFIG]: async ({ state, commit }, params) => {
    // console.log('GTAG_CONFIG', params.data)
    gtag('config', 'G-HCLBKFJXVZ', params.data)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
